import { inject } from 'vue';

export const useSystemIDE = () => {
    return inject('$systemIDE', {
        emitRefreshMenu () {
            console.log('[useSystemIDE] emitRefreshMenu');
        },
        'getCurrentPage' () {
            console.log('[useSystemIDE] getCurrentPage');
            return null;
        },
        historyRouteBar: {
            closeCurrent () {
                console.log('[useSystemIDE] closeCurrent');
            },
            closeOther () {
                console.log('[useSystemIDE] closeOther');
            },
            closeAll () {
                console.log('[useSystemIDE] closeAll');
            },
            getHistoryRoutes () {
                console.log('[useSystemIDE] getHistoryRoutes');
                return [];
            },
            setCurrentTabTitle (title) {
                console.log('[useSystemIDE] setCurrentTabTitle', title);
            },
            setTabTitle (oRoute, title) {
                console.debug('[useSystemIDE] set tabTitle', oRoute, title);
            },
        },
    });
};
